import React, { Component } from "react";
import { Row, Col, Table, Tooltip, OverlayTrigger } from "react-bootstrap";
import moment from "moment";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchHolidaysRequest, deleteHolidayRequest } from "../../../api/holiday";

class HolidaysTable extends Component {

  state = {
    data: null,
    error: null,
    loading: false
  };

  componentDidMount() {
    if (!this.state.data)
      this.fetchHolidaysData()
  }

  componentDidUpdate(prevProps) {
    if(prevProps.selectedLocation !== this.props.selectedLocation) {
      this.fetchHolidaysData();
    }
  }

  fetchHolidaysData(){
    this.setState({
      loading: true
    });
    fetchHolidaysRequest(
      this.props.selectedLocation,
      result => this.setState({data: result, error: null, loading: false}),
      error => this.setState({error: error.message, loading: false})
    )
  };

  deleteHolidays = (id) => {
    deleteHolidayRequest(
      id,
      result => this.fetchHolidaysData(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );

  }

  render() {
    const { data } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    return (
      <div className="content">
          <Row>
            <Col md={12}>
              <Card
                title="Holidays Table"
                category="List of Holidays entries to DB"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div>
                    <CustomButtom className="table-top-btn btn-primary" onClick={() => this.props.goToCreateForm('holidays')}>
                      New Entry
                    </CustomButtom>
                    <Table striped hover>
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Type</th>
                          <th>Area</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.loading ?
                          <td colSpan="4" style={{padding: "0"}}>
                            <div className="loader"></div>
                          </td> 
                          :
                          (data && data.length > 0) 
                          ? data.map(instance => {
                            return (
                              <tr key={instance._id}>
                                {console.log()}
                                <td>{instance.holidayDate ? moment.utc(instance.holidayDate).format('MM/DD/YYYY') : 'N/A'}</td>
                                <td>{instance.holidayType || "N/A"}</td>
                                <td>{instance.area?.areaName || "N/A"}</td>
                                <td className="td-actions text-right">
                                  <OverlayTrigger placement="top" overlay={view}>
                                    <CustomButtom 
                                      bsStyle="success" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToDetails('holidays', instance._id)}
                                    >
                                      <i className="fa fa-eye" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={edit}>
                                    <CustomButtom 
                                      bsStyle="info" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.props.goToEditForm('holidays', instance._id)}
                                    >
                                      <i className="fa fa-edit" />
                                    </CustomButtom>
                                  </OverlayTrigger>

                                  <OverlayTrigger placement="top" overlay={remove}>
                                    <CustomButtom 
                                      bsStyle="danger" 
                                      simple 
                                      type="button" 
                                      bsSize="xs"
                                      onClick={() => this.deleteHolidays(instance._id)}
                                    >
                                      <i className="fa fa-times" />
                                    </CustomButtom>
                                  </OverlayTrigger>
                                </td>
                              </tr>
                            )}
                          )
                          : (
                            <tr>
                              <td colSpan='4'>There are no instances in the database yet.</td>
                            </tr>
                          )
                        }
                      </tbody>
                    </Table>
                  </div>
                }
              />
            </Col>
          </Row>
      </div>
    );
  }
}

export default HolidaysTable;
